import { StateCreator } from "zustand";
import { SearchType } from "ui-components";

import { RootStore } from ".";

export interface SearchState {
	currentSearchType: SearchType;
	currentSearchInput: string;
}

export interface SearchActions {
	setCurrentSearchType: (value: SearchType) => void;
	setCurrentSearchInput: (value: string) => void;
}

export type SearchStore = SearchState & SearchActions;

export const createSearchSlice: StateCreator<RootStore, [], [], SearchStore> = (
	set,
) => ({
	currentSearchType: "address",
	currentSearchInput: "",
	setCurrentSearchType: (value) => set({ currentSearchType: value }),
	setCurrentSearchInput: (value) => set({ currentSearchInput: value }),
});
